// src/utils/tabbar.ts
import type { TelegramWebApp } from '@/types'

export function initTabBar(): void {
  const nav = document.getElementById('topNav') as HTMLElement | null
  if (!nav) return

  const applySpace = (): void => {
    const h = nav.getBoundingClientRect().height
    document.documentElement.style.setProperty('--tabbar-space', `${Math.ceil(h)}px`)
  }
  applySpace()
  new ResizeObserver((): void => applySpace()).observe(nav)
  window.addEventListener('load', applySpace)
  setTimeout(applySpace, 0)

  const isTextInputActive = (): boolean => {
    const ae = (document.activeElement as HTMLElement | null)
    if (!ae) return false
    if (ae.tagName === 'INPUT' || ae.tagName === 'TEXTAREA') return true
    if (ae.isContentEditable) return true
    return false
  }

  // Typed Telegram object (no 'any')
  const tg: TelegramWebApp | undefined = window.Telegram?.WebApp
  if (tg) {
    tg.ready?.()
    tg.expand?.()

    const onViewport = (): void => {
      const stable = tg.viewportStableHeight ?? tg.viewportHeight ?? window.innerHeight
      const current = tg.viewportHeight ?? window.innerHeight
      const delta = (stable ?? current) - current
      const keyboardOpen = !document.body.classList.contains('cookie-opening') && delta > 160 && isTextInputActive()
      document.body.classList.toggle('body-keyboard', keyboardOpen)
      applySpace()
    }
    tg.onEvent?.('viewportChanged', onViewport)
    onViewport()
  } else if (window.visualViewport) {
    // Dev fallback outside Telegram
    const vv = window.visualViewport
    const onVV = (): void => {
      const delta = window.innerHeight - vv.height
      const keyboardOpen = !document.body.classList.contains('cookie-opening') && delta > 200 && isTextInputActive()
      document.body.classList.toggle('body-keyboard', keyboardOpen)
      applySpace()
    }
    vv.addEventListener('resize', onVV)
    onVV()
  }
}
